$(document).ready(function() {
	if(!document.querySelector('.reporting-step-area')) return false;
	
	var el = $('#reporting-form');
	var reportingDestinationValue = $(el).find('input[name="objects-1"]:checked').val();
	var typeOfObjectValue = $(el).find('input[name="objects-2"]:checked').val();
	var companyRelationValue = $(el).find('input[name="objects_company-1"]:checked').val();
	var thirdPartyAgreeChecked = false;
	var form = {
		file : $(el).find('#file'),
		reportTitle : $(el).find('#report-title'),
		reportTitleCount : $(el).find('#report-title').siblings('.left-text').find('.count'),
		reportContent : $(el).find('#report-contents'),
		reportContentCount : $(el).find('#report-contents').siblings('.left-text').find('.count'),
		reportIdErrorMsg : $(el).find('#report-id').siblings('.error-msg'),
		reportIdErrorMsgSpan : $(el).find('#report-id').siblings('.error-msg').find('span.required'),
		resultDoubleCheck : $(el).find('#result-double-check'),
		reportIdErrorMsgClickBtnSpan : $(el).find('#report-id').siblings('.error-msg').find('span.click-btn'),
		reportIdErrorMsgInputEmptySpan : $(el).find('#report-id').siblings('.error-msg').find('span.input-empty'),
		reportPasswordErrorMsgSpan : $(el).find('#report-password').siblings('.error-msg').find('span.required'),
		reportPasswordErrorMsgInvaliedSpan : $(el).find('#report-password').siblings('.error-msg').find('span.invalid'),
		reportPasswordErrorMsgInputEmptySpan : $(el).find('#report-password').siblings('.error-msg').find('span.input-empty'),
		emailErrorMsgSpan : $(el).find('#report-email').siblings('.error-msg').find('span.required'),
		reportTelErrorMsgSpan : $(el).find('#report-tel').siblings('.error-msg').find('span.required'),
		reportTelErrorMsgOnlyNumSpan : $(el).find('#report-tel').siblings('.error-msg').find('span.only-number'),
		reportTelErrorMsgInputEmptySpan : $(el).find('#report-tel').siblings('.error-msg').find('span.input-empty'),
		reportReconfirmErrorMsgNoneEqualsSpan : $(el).find('#report-reconfirm').siblings('.error-msg').find('span.none-equals'),
		reportReconfirmErrorMsgInputEmptySpan : $(el).find('#report-reconfirm').siblings('.error-msg').find('span.input-empty'),
		inputInfoTextSolicitation : $(el).find('#input-info-text-solicitation'),
		inputInfoTextEmbezzlement : $(el).find('#input-info-text-embezzlement'),
		inputInfoTextEnvironmental : $(el).find('#input-info-text-environmental'),
		inputInfoTextUnfair : $(el).find('#input-info-text-unfair'),
		inputInfoTextDocument : $(el).find('#input-info-text-document'),
		inputInfoTextWorkplace : $(el).find('#input-info-text-workplace'),
		reportTypeInputInfoText : $(el).find('#report-type-input-info-text'),
		input : {
			reportId : $(el).find('#report-id'),
			reportPassword : $(el).find('#report-password'),
			reportReconfirm : $(el).find('#report-reconfirm'),
			reportName  : $(el).find('#report-name'),
			reportEmail : $(el).find('#report-email'),
			reportTel : $(el).find('#report-tel'),
			reportTitle : $(el).find('#report-title'),
			reportContents : $(el).find('#report-contents'),
			reportObject : $(el).find('#report-object'),
			reportDepartment : $(el).find('#report-department'),
			verificationToken : $(el).find('#requestVerificationToken'),
			reportingType : $(el).find('#reporting-type'),
			captchaCodeTextBox : $(el).find('#captchaCodeTextBox'),
			customizedCaptcha : $(el).find('#LBD_VCID_customizedCaptcha')
		},	
		option : {
			reportType : $(el).find('#report-type')
		},
		button : {
			doubleBtnCheckBtn : $(el).find('#double-check-btn'),
			cancelBtn : $(el).find('#cancel-btn'),
			submitBtn : $(el).find('#submit-btn')
		},
		radio :{
			reportingDestination : $(el).find('input[name="objects-1"]'),
			typeOfObject : $(el).find('input[name="objects-2"]'),
			companyRelation : $(el).find('input[name="objects_company-1"]')
		},
		checkbox : {
			thirdPartyAgree : $(el).find('input[name="agree-02"]')
		},
		init : function(){
			var _self = form;
			this.file.fileUploadSet();
			checkTextLength(this.reportTitle, this.reportTitleCount);
			checkTextLength(this.reportContent, this.reportContentCount);
			this.button.doubleBtnCheckBtn.off("click").on("click", function(e){
				_self.doubleCheck();
			});
			this.input.reportId.on('change', function(){
				_self.changeVerificationID();
			});
			this.button.submitBtn.off("click").on("click", function(e){
				_self.validationCheck();
			});
			this.button.cancelBtn.off("click").on("click", function(e){
				modal.realNameReportCancel.modalWindow.modal('show');
			});
		},
		doubleCheck : function(){	
			var reportId = this.input.reportId.val();
			
			if("" == reportId || null == reportId){
				this.reportIdErrorMsg.show();
				this.reportIdErrorMsgSpan.show();				
			}else{
				var url  = this.button.doubleBtnCheckBtn.attr('ajax-url');
				
				var headers = {};
				headers["Content-type"] = "application/json";
				
				var data = {};
				data.userId = reportId;
				
				$.ajax({
					url : url,
					headers : headers,
					async: false,
					type : 'post',
					data : JSON.stringify(data),
					dataType : 'json',
					success : function(data){
						var result = data.result;
						var msg = data.msg;
						$(form.reportIdErrorMsgSpan).text(msg);						
						if(result){
							$(form.resultDoubleCheck).val('Y');
							$(form.reportIdErrorMsg).hide();
						}else{
							$(form.resultDoubleCheck).val('N');
							$(form.reportIdErrorMsg).show();
							$(form.reportIdErrorMsgSpan).show();	
						}
					},
					error : function(request, status, error){
						console.log("code:" + request.status + "\n" + "message:" + request.responseText + "\n" + "error:" + error);
					
					}
				});
			}
		},
		changeVerificationID : function(){
			this.reportIdErrorMsg.hide();
			
			this.resultDoubleCheck.val('N');
			
			if(null != this.input.reportId.val() && "" != this.input.reportId.val()){
				this.reportIdErrorMsgSpan.text(this.reportIdErrorMsgClickBtnSpan.text());
			}else{
				this.reportIdErrorMsgSpan.text(this.reportIdErrorMsgInputEmptySpan.text());
			}
		},
		validationCheck : function(){
			if($(form.input.reportEmail).closest('.field-block').hasClass('error')){
				$(form.input.reportEmail).focus();
				return false;
			}
			if($(form.input.reportTel).closest('.field-block').hasClass('error')){
				$(form.input.reportTel).focus();
				return false;
			}
			$(el).find('.error-msg').hide();			
			if($(el).checkValidation()){
				if('Y' == this.resultDoubleCheck.val()){
					if(this.input.reportPassword.val() == this.input.reportReconfirm.val()){
						this.input.reportReconfirm.siblings('.error-msg').find('.required').text(this.reportReconfirmErrorMsgInputEmptySpan.text());
						modal.realNameReportConfirm.modalWindow.modal('show');	
					}else{
						this.input.reportReconfirm.siblings('.error-msg').find('.required').text(this.reportReconfirmErrorMsgNoneEqualsSpan.text());
						this.input.reportReconfirm.closest('.field-block').addClass('error');
						this.input.reportReconfirm.attr('aria-invalid', 'true');
						this.input.reportReconfirm.attr('aria-describedby', 'report-reconfirmError');
						this.input.reportReconfirm.siblings('.error-msg').find('.required').show();
						this.input.reportReconfirm.siblings('.error-msg').show();
						this.input.reportReconfirm.focus();
		    			return false;
					}			
				}else{
		    		if(null != $('#report-id').val() && "" != $('#report-id').val()){
		    			this.reportIdErrorMsgSpan.text(this.reportIdErrorMsgClickBtnSpan.text());
		    			this.input.reportId.closest('.field-block').addClass('error')
		    			this.input.reportId.attr('aria-invalid', 'true');
		    			this.input.reportId.attr('aria-describedby', 'report-idError');
		    			this.reportIdErrorMsg.show();
		    			this.reportIdErrorMsgSpan.show();
		    			this.input.reportId.focus();
		    			return false;
		    		}else{
		    			this.reportIdErrorMsgSpan.text(this.reportIdErrorMsgInputEmptySpan.text());
		    			this.input.reportId.closest('.field-block').addClass('error')
		    			this.input.reportId.attr('aria-invalid', 'true');
		    			this.input.reportId.attr('aria-describedby', 'report-idError');
		    			this.reportIdErrorMsg.show();
		    			this.reportIdErrorMsgSpan.show();
		    			this.input.reportId.focus();
		    			return false;
		    		}					
				}
			}else{
				if('N' == this.resultDoubleCheck.val()){
					this.input.reportId.closest('.field-block').addClass('error')
	    			this.input.reportId.attr('aria-invalid', 'true');
	    			this.input.reportId.attr('aria-describedby', 'report-idError');
	    			this.reportIdErrorMsgSpan.show();
				}
		    	$(el).find('.field-block.error').find('.error-msg').show();
		    	return false;
		    }
		},
		insertReporting : function(){	
			var formData = new FormData();
			formData.append("report-name", this.input.reportName.val());
			formData.append("report-email", this.input.reportEmail.val());
			formData.append("report-tel", this.input.reportTel.val());
			formData.append("report-type", $(form.option.reportType).find('option:selected').val());
			formData.append("report-title", this.input.reportTitle.val());
			formData.append("report-contents", this.input.reportContents.val());
			formData.append("report-id", this.input.reportId.val());
			formData.append("report-password", this.input.reportPassword.val());
			formData.append("requestVerificationToken", this.input.verificationToken.val());
			$(el).find('input.docImgUploadFile').each(function(){
				formData.append($(this).attr('name'), $(this)[0].files[0]);
			});
			formData.append("reporting-type", this.input.reportingType.val());
			formData.append("captchaCodeTextBox", this.input.captchaCodeTextBox.val());
			formData.append("LBD_VCID_customizedCaptcha", this.input.customizedCaptcha.val());
			formData.append("objects-1", reportingDestinationValue);
			formData.append("object_of_report_type", typeOfObjectValue);
			formData.append("object_of_report", this.input.reportObject.val());
			formData.append("object_of_report_department", this.input.reportDepartment.val());
			formData.append("object_of_report_relation_company", companyRelationValue);
			formData.append("personalInfoAgree", "Y");
			if(true == thirdPartyAgreeChecked){
				formData.append("thirdPartyAgree", "Y");
			}else{
				formData.append("thirdPartyAgree", "N");
			}
			
			/* LGEGMC-5323 start */
			if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y"){
				formData.append("recaptchaPageType", $("#recaptchaPageType").val());
				
				if( !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
					var reCaptcha_Key = $('#siteKey').val();
					
		        	grecaptcha.enterprise.ready(function() {
		        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
		        			formData.append("verifyKey", btoa(token));
		        			formAnSubmit();
		        		});
		        	});
		        	
				}else if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
					formData.append("verifyKey", $("#verifyKey").val());
					formAnSubmit();
				}else{
					formAnSubmit();
				}
			}else{
				formAnSubmit();
			}
			
			var headers = {};
			headers["Content-type"] = "application/json";
			
			function formAnSubmit(){
				$.ajax({
					async: false,
					type:"POST",
					url: $('#reporting-form').attr('ajax-url'),
					processData: false,
					contentType: false,
					data: formData,
					success: function(data){
						var captcha = data.captcha;
						var errorReason = data.errorReason;
						if(null != captcha && "" != captcha ){
							var errorMsg = captcha.error.captchaCodeTextBox;
							$(form.input.captchaCodeTextBox).siblings('.error-msg').find('.ajax-msg').text(errorMsg);
							$(form.input.captchaCodeTextBox).closest('.field-block').addClass('error');
							$(form.input.captchaCodeTextBox).attr('aria-invalid', 'true');
			    			$(form.input.captchaCodeTextBox).attr('aria-describedby', 'captchaCodeTextBoxError');
							$(form.input.captchaCodeTextBox).siblings('.error-msg').find('.ajax-msg').show();
							$(form.input.captchaCodeTextBox).siblings('.error-msg').show();
							$(form.input.captchaCodeTextBox).focus();
			    			return false;
						}
						if(null != errorReason && "userId" == errorReason){
							var errorMsg = data.errorMsg;
							$(form.reportIdErrorMsgSpan).text(errorMsg);
							$(form.input.reportId).closest('.field-block').addClass('error')
							$(form.input.reportId).attr('aria-invalid', 'true');
							$(form.input.reportId).attr('aria-describedby', 'report-idError');
							$(form.reportIdErrorMsg).show();
							$(form.reportIdErrorMsgSpan).show();
							$(form.input.reportId).focus();
			    			return false;
						}
						
						var result = data.result;
						if(result){
							modal.receptionCompleted.modalWindow.modal('show');
						}else{
							// LGEGMC-5375 start
							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
								if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
									reload_recaptcha_wrapper();
								}
							}
							// LGEGMC-5375 end
						}
					},
					error: function(error){
					    console.log("error:", error);
					}
				});	
			}
			/* LGEGMC-5323 end */
		}
	}
	
	var modal = {
		realNameReportConfirm : {
			modalWindow : $('#modal_RealNameReport_confrim'),
			modalConfirm : $('#modal_RealNameReport_confrim').find('#submit-confirm-btn'),
			init : function(){
				this.modalConfirm.off("click").on("click", function(e){
					form.insertReporting();
				});
			}
		},
		realNameReportCancel : {
			modalWindow : $('#modal_RealNameReport_cancel'),
			modalConfirm : $('#modal_RealNameReport_cancel').find('#submit-confirm-btn'),
			init : function(){
				this.modalConfirm.off("click").on("click", function(e){
					var url = modal.realNameReportCancel.modalConfirm.attr('move-url');
					$(modal.cancelCompleted.modalWindow).modal('show');
				});
			}
		},
		receptionCompleted : {
			modalWindow : $('#modal_reception_completed'),
			home : $('#modal_reception_completed').find('#home-btn'),
			init : function(){
				this.home.off("click").on("click", function(e){
					var url = modal.receptionCompleted.home.attr('move-url');
					location.replace(url);
				});
			}
		},
		cancelCompleted : {
			modalWindow : $('#modal_cancel_completed'),
			home : $('#modal_cancel_completed').find('#home-btn'),
			init : function(){
				this.home.off("click").on("click", function(e){
					var url = modal.receptionCompleted.home.attr('move-url');
					location.replace(url);
				});
			}
		},
		modalJeongdoInfo : {
			modalWindow    : $('#modal-jeongdo-info'),
            modalEssential : $('#modal-essential-info'),
            init : function(){
            	var countryCode = $('html').data('countrycode');
             	if(countryCode =='fr'){
             		this.modalEssential.modal('show');
             	}else{
             		this.modalWindow.modal('show');
             	}
            }
		}
	}
	var regCheckFn = {
		init : function(){	
			$(form.input.reportEmail).on('change', function(e){
				if('' == $(this).val()){
					$(this).closest('div.field-block').removeClass('error');
	    			$(this).attr('aria-invalid', '');
					$(this).attr('aria-describedby', '');
					$(this).siblings('.error-msg').hide();
				}else{
					if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($(this).val())){
						$(this).closest('div.field-block').removeClass('error');
		    			$(this).attr('aria-invalid', '');
						$(this).attr('aria-describedby', '');
						$(this).siblings('.error-msg').hide();
					}else{
						$(this).closest('div.field-block').addClass('error');
		    			$(this).attr('aria-invalid', 'true');
						$(this).attr('aria-describedby', 'report-emailError');
						$(this).siblings('.error-msg').show();
						$(this).siblings('.error-msg').find('span.required').show();
						$(this).focus();
					}
				}
			});
			$(form.input.reportTel).on('change', function(e){
				if(/^([0-9])+$/.test($(this).val())){
					$(form.reportTelErrorMsgSpan).text($(form.reportTelErrorMsgInputEmptySpan).text());
					$(this).closest('div.field-block').removeClass('error');
	    			$(this).attr('aria-invalid', '');
					$(this).attr('aria-describedby', '');
					$(this).siblings('.error-msg').hide();
				}else{
					$(form.reportTelErrorMsgSpan).text($(form.reportTelErrorMsgOnlyNumSpan).text());
					$(this).closest('div.field-block').addClass('error');
	    			$(this).attr('aria-invalid', 'true');
					$(this).attr('aria-describedby', 'report-telError');
					$(this).siblings('.error-msg').show();
					$(this).siblings('.error-msg').find('span.required').show();
					$(this).focus();
				}
			});
			$(form.input.reportPassword).on('change', function(e){
				if(/(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?])[A-Za-z\d!@#$%^&*?]{8,}/g.test($(this).val())){
					$(form.reportPasswordErrorMsgSpan).text($(form.reportPasswordErrorMsgInputEmptySpan).text());
					$(this).closest('div.field-block').removeClass('error');
	    			$(this).attr('aria-invalid', '');
					$(this).attr('aria-describedby', '');
					$(this).siblings('.error-msg').hide();
					$(this).siblings('.error-msg').find('span.required').hide();
				}else{
					$(form.reportPasswordErrorMsgSpan).text($(form.reportPasswordErrorMsgInvaliedSpan).text());
					$(this).closest('div.field-block').addClass('error');
	    			$(this).attr('aria-invalid', 'true');
					$(this).attr('aria-describedby', 'report-passwordError');
					$(this).siblings('.error-msg').show();
					$(this).siblings('.error-msg').find('span.required').show();
					$(this).focus();
				}
			});
			$(form.option.reportType).on('change', function(e){
				$(this).closest('.field-block').siblings('.input-info-text').hide();
				if('RT0001' == $(this).val()){
					$(form.inputInfoTextSolicitation).show();
				}else if('RT0002' == $(this).val()){
					$(form.inputInfoTextEmbezzlement).show();
				}else if('RT0003' == $(this).val()){
					$(form.inputInfoTextEnvironmental).show();
				}else if('RT0004' == $(this).val()){
					$(form.inputInfoTextUnfair).show();
				}else if('RT0005' == $(this).val()){
					$(form.inputInfoTextDocument).show();
				}else if('RT0006' == $(this).val()){
					$(form.inputInfoTextWorkplace).show();
				}else{
					$(form.reportTypeInputInfoText).show();
				}
			});	
			$(form.radio.reportingDestination).on('change', function(e){
				reportingDestinationValue = $(el).find('input[name="objects-1"]:checked').val();
			});			
			$(form.radio.typeOfObject).on('change', function(e){
				typeOfObjectValue = $(el).find('input[name="objects-2"]:checked').val();
			});			
			$(form.radio.companyRelation).on('change', function(e){
				companyRelationValue = $(el).find('input[name="objects_company-1"]:checked').val();
			});
			$(form.checkbox.thirdPartyAgree).on('change', function(e){
				thirdPartyAgreeChecked = $(el).find('input[name="agree-02"]').is(':checked');
			});
		}
	}
	
	form.init();
	modal.realNameReportConfirm.init();
	modal.realNameReportCancel.init();
	modal.receptionCompleted.init();
	modal.cancelCompleted.init();
	regCheckFn.init();
	modal.modalJeongdoInfo.init();
});